"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgIcon_1 = __importDefault(require("@material-ui/core/SvgIcon"));
var DeviceTagIcon = function (props) {
    // Included due to svg size
    var defaults = __assign({ viewBox: "0 0 100 100" }, props);
    return (react_1.default.createElement(SvgIcon_1.default, __assign({}, defaults),
        react_1.default.createElement("path", { fillRule: "nonZero", d: "M11.6,21.2 L2,21.2 L2,88.4 C2,93.704 6.296,98 11.6,98 L78.8,98 L78.8,88.4 L11.6,88.4 L11.6,21.2 Z" }),
        react_1.default.createElement("path", { fillRule: "nonZero", d: "M88.4,2 C93.704,2 98,6.296 98,11.6 L98,69.2 C98,74.504 93.704,78.8 88.4,78.8 L30.8,78.8 C25.496,78.8 21.2,74.504 21.2,69.2 L21.2,11.6 C21.2,6.296 25.496,2 30.8,2 L88.4,2 Z M45.6666667,37.7866667 L51.5333333,31.8933333 C52.2666667,31.16 52.48,30.1066667 52.1866667,29.1866667 C51.2,26.2 50.6666667,22.9866667 50.6666667,19.6666667 C50.6666667,18.1866667 49.48,17 48,17 L38.6666667,17 C37.2,17 36,18.1866667 36,19.6666667 C36,44.7066667 56.2933333,65 81.3333333,65 C82.8133333,65 84,63.8133333 84,62.3333333 L84,53 C84,51.52 82.8133333,50.3333333 81.3333333,50.3333333 C78.0133333,50.3333333 74.8,49.8 71.8133333,48.8133333 C70.8933333,48.52 69.84,48.7333333 69.1066667,49.4666667 L63.24,55.3466667 C55.68,51.5066667 49.5066667,45.3333333 45.6666667,37.7866667 Z" })));
};
exports.default = DeviceTagIcon;
